module.exports = __webpack_public_path__ + "static/media/TapThinDenseRoot3.a380b723.PNG";